var map = {
	"./2024-mothers-day/au/desktop.jpg": 7449,
	"./2024-mothers-day/na/desktop.jpg": 63780,
	"./fathersday/desktop.jpg": 23619,
	"./generic/desktop.jpg": 48541,
	"./holiday/desktop.jpg": 54006,
	"./mothersday/au/desktop.jpg": 33645,
	"./mothersday/desktop.jpg": 82908,
	"./mothersday/na/desktop.jpg": 14120,
	"./valentines/desktop.jpg": 61491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64796;